import React, { useState } from 'react';
import { AppBar, Box, Toolbar, IconButton, Typography, Drawer, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { FaRupeeSign, FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import ShareIcon from '@mui/icons-material/Share';
import { useNavigate } from 'react-router-dom';
import Avatar from 'react-avatar';
import { useRechargeOptions } from './RechargeOptionsContext';
import { useUser } from './UserContext'; // Import UserContext
import BottomSheetShare from './BottomSheetShare';

const Header = ({ onWalletOpen, onTermConditionOpen }) => {
  const [open, setOpen] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const isMobile = true; // Assuming mobile view for this example
  const logoUrl = '/logo-vertical.jpg';
  const { walletBalance } = useRechargeOptions();
  const navigate = useNavigate();
  const { user } = useUser(); // Use UserContext

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleCloseDrawer = () => {
    setOpen(false);
  };

  const handleOpenDrawer = () => {
    setOpen(true);
  };

  const handleOpenBottomSheet = () => {
    setIsBottomSheetOpen(true);
  };

  const handleCloseBottomSheet = () => {
    setIsBottomSheetOpen(false);
  };

  const handleOpenFacebook = () => {
    const fbWebUrl = 'https://www.facebook.com/people/Astroyami/100088818350879/';
    window.open(fbWebUrl, '_blank');
  };

  const handleOpenInstagram = () => {
    const instaWebUrl = 'https://www.instagram.com/astroyamiai/';
    window.open(instaWebUrl, '_blank');
  };

  const handleOpenYouTube = () => {
    const youtubeWebUrl = 'https://www.youtube.com/@ASTROYAMI';
    window.open(youtubeWebUrl, '_blank');
  };

  const shareUrl = 'https://play.google.com/store/apps/details?id=com.astroyami.com';
  const title = 'Discover Astroyami - Your Personal AI Astrologer! Download now for personalized insights.';

  const desktopMenu = (
    <div>
      <div className="header-wrap fixed-top">
        {/* Add your desktop menu items here */}
      </div>
    </div>
  );

  const mobileMenu = (
    <div>
      <Box sx={{ flexGrow: 1 }} className="header-wrap">
        <AppBar className="header-inner" position="fixed" sx={{ backgroundColor: '#ffffff' }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleOpenDrawer}
              className="menu-btn"
            >
              <MenuIcon />
            </IconButton>
            {logoUrl ? (
              <img src={logoUrl} alt="Logo" style={{ width: 55, height: 'auto', marginRight: 'auto' }} />
            ) : (
              <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
                Astroyami
              </Typography>
            )}
            <Box sx={{ flexGrow: 1 }} />
             <Box className="wallet-btn" onClick={onWalletOpen}>
              
              <span><FaRupeeSign />{walletBalance}/-</span>
            </Box> 
            <Box className="share-button" >
              <IconButton color="inherit" onClick={handleOpenBottomSheet}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Drawer
          anchor="left"
          open={open}
          onClose={handleCloseDrawer}
          sx={{ '& .MuiDrawer-paper': { backgroundColor: 'white' } }}
        >
          <Box sx={{ width: 250 }} role="presentation">
            <IconButton className="close-drawer"
              onClick={handleCloseDrawer}
              sx={{ position: 'relative', top: 5, left: 200, margin: 0, color: 'black' }}
            >
              <CloseIcon />
            </IconButton>
            <Box sx={{ textAlign: 'center' }} className="menu-drawer-wrap">
              {user && (
                <>
                  <Avatar name={user.name || user.phone} round={true} size="100" />
                  <Typography variant="h6" sx={{ marginTop: 1 }} className="avtar-info">{user.name}</Typography>
                </>
              )}
            </Box>
            <List className="drawer-links">
              <ListItemButton onClick={handleCloseDrawer} className="links-profile">
                <ListItemIcon className="link-icon"><GavelIcon /></ListItemIcon>
                <ListItemText onClick={onTermConditionOpen} className="link-txt" primary="Terms & Conditions" />
              </ListItemButton>

              <ListItemButton  onClick={() => window.open('https://play.google.com/store/apps/details?id=com.astroyami.com')}  className="links-profile">
                <ListItemIcon className="link-icon"><FeedbackIcon /></ListItemIcon>
                <ListItemText className="link-txt" primary="Rate Us on Playstore" />
              </ListItemButton>

              <ListItemButton onClick={() => window.open('https://wa.me/917087024959')} className="links-profile">
                <ListItemIcon className="link-icon"><FaWhatsapp /></ListItemIcon>
                <ListItemText className="link-txt" primary="WhatsApp Chat" />
              </ListItemButton>

              <ListItemButton onClick={() => window.open('tel:+917087024959')} className="links-profile">
                <ListItemIcon className="link-icon"><PhoneIcon /></ListItemIcon>
                <ListItemText className="link-txt" primary="Call Us" />
              </ListItemButton>

              <ListItemButton sx={{ marginTop: 'auto' }} className="links-profile" onClick={handleLogout}>
                <ListItemIcon className="link-icon"><LogoutIcon /></ListItemIcon>
                <ListItemText className="link-txt" primary="Logout" />
              </ListItemButton>
            </List>
            <Box className="social-media-wrap">
              <h6>Also available on</h6>
              <IconButton onClick={handleOpenFacebook}>
                <FaFacebook />
              </IconButton>
              <IconButton onClick={handleOpenInstagram}>
                <FaInstagram />
              </IconButton>
              <IconButton onClick={handleOpenYouTube}>
                <FaYoutube />
              </IconButton>
            </Box>
          </Box>
        </Drawer>
        <BottomSheetShare
          open={isBottomSheetOpen}
          onDismiss={handleCloseBottomSheet}
          shareUrl={shareUrl}
          title={title}
        />
      </Box>
    </div>
  );

  return isMobile ? mobileMenu : desktopMenu;
};

export default Header;
